'use client'

import {List} from '../../data'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import Link from 'next/link'
import {LanguageCodes} from '@app/i18n/settings'
import {generateCanonicalGameUrl, generateCanonicalTagUrl} from '@app/script/seo/faq/homepage'
import clsx from 'clsx'

type Props = {
  item: List
  propertyCode: string
  layout: string
  id: number
  lang: LanguageCodes
  className?: string
}

const AccordionLink = ({item, propertyCode, layout, id, lang, className}: Props) => {
  return (
    <>
      {item.type === 'game' && (
        <Link
          href={generateCanonicalGameUrl({
            gameCode: item.code,
            gameName: item.name,
            lang,
          })}
          className={clsx('underline', className)}
          onClick={
            triggerAnalytics('game-card-clicked', {
              'game-name': item.name,
              'game-code': item.code,
              layout: layout,
              'accordion-id': id,
            }).sendAll
          }
          target='_blank'
          prefetch={false}
        >
          <span className={className}>{item.name}</span>
        </Link>
      )}
      {item.type === 'tag' && (
        <Link
          href={generateCanonicalTagUrl({
            lang,
            name: item.name,
            tagId: item.code,
          })}
          className={clsx('underline', className)}
          onClick={
            triggerAnalytics('game-category-clicked', {
              'category-name': item.nameEn || item.name,
              layout: layout,
              'accordion-id': id,
            }).sendAll
          }
          target='_blank'
          prefetch={false}
        >
          {item.name}
        </Link>
      )}
    </>
  )
}

export default AccordionLink
